import { AuthService } from './../../../core/services/auth.service';
import { TokensAddedComponent } from '../tokens-added/tokens-added.component';
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { WalletService } from 'src/app/core/services/wallet.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { TokensGiftedComponent } from '../tokens-gifted/tokens-gifted.component';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';

declare var Stripe: any;
@Component({
  selector: 'app-enter-otp',
  templateUrl: './enter-otp.component.html',
  styleUrls: ['./enter-otp.component.scss']
})
export class EnterOtpComponent implements OnInit {

  @Input() public giftUserData;
  @Input() public paramData;
  @Input() public phone_number;
  @Input() public ico;
  @Input() public numFlag;

  OTPForm: FormGroup;
  submitted: boolean = false;
  hasError: boolean = false;
  errorMessage: any;
  counter: any;
  sessionId: any;
  otpResend = false;
  isSuppAccount = false;
  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private _authService: AuthService,
    private _walletService: WalletService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.OTPForm = this.formBuilder.group({
      one_time_password: ['', [Validators.required, Validators.max(999999)]]
    });
    this.isSuppAccount = this._authService.isSupplementaryAccount();
    this.startCountDown(10);
  }
  closeDialog() {
    this.activeModal.dismiss(false);
  }

  onSubmit() {
    this.submitted = true;
    if (this.OTPForm.invalid) {
      return;
    }
    if (this.giftUserData && this.giftUserData.source && this.giftUserData.source != undefined) {
      switch (this.giftUserData.source) {
        // gift token case
        case 'giftTokenNoBack': {
          this.giftToken();
          break;
        }
        case 'transferTokenNoBack': {
          this.transferToken();
          break;
        }
        case 'withdrawtokennoback': {
          this.withdrawTokens();
          break;
        }
        default: {
          this.verifyOTP();
          break;
        }
      }
    } else {
      this.verifyOTP();
    }
  }

  verifyOTP() {
    const params = {
      // ...this.giftUserData,
      ...this.OTPForm.value,
      ...this.phone_number,
      'ico': this.ico
    };
    this.spinner.show();
    this._walletService.verifyOTP(params).subscribe(
      (response: any) => {
        if (response.success) {
          let user = this._authService.getCurrentUser();
          if (user.user) {
            user.user.international_phone_number = this.phone_number.country_code + "" + this.phone_number.phone_number;
            user.user.phone = this.phone_number.phone_number;
            user.user.country_code = this.phone_number.country_code;
            user.user.ico = this.ico;
            localStorage.setItem('currentUser', JSON.stringify(user));

            if (this.giftUserData && this.giftUserData.source && (this.giftUserData.source === 'giftToken' || this.giftUserData.source == 'transferToken' || this.giftUserData.source == 'withdrawtoken')) {
              this.spinner.hide();
              this.activeModal.close('success');
            }
            else if (this.giftUserData && this.giftUserData.source && this.giftUserData.source === 'addToken') {
              this.redirectToStripe();
              return;
            }
            else {
              this.spinner.hide();
              const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
              modelRef.componentInstance.message = "Your Mobile number has been successfully verified";
              this.activeModal.close('success');
            }
          }
          else {
            this.spinner.hide();
            const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modelRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.SESSION_EXPIRED;
          }
          //this.closeDialog();

          if (!this.phone_number.phone_number) {
            this.spinner.hide();
            const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.GIFT_TOKEN_SUCCESS;
          }

        }
        else {
          this.spinner.hide();
          this.hasError = true;
          this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.OTP_INVALID;
        }
      }, (error: any) => {
        this.spinner.hide();
        this.hasError = true;
        this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.OTP_INVALID;
      });
  }

  /**
   * Gift token API
   * params : User id, token, OTP
   *
   * @memberof EnterOtpComponent
   */
  giftToken() {
    this.spinner.show();
    const params = {
      ...this.giftUserData,
      ...this.OTPForm.value
    }
    this._walletService.giftTokens(params).subscribe((response: any) => {
      this.spinner.hide();
      if (response.success) {
        response.data.account_transaction.transaction_flow = 'debit';
        response.data.account_transaction.closing_balance = response.data.account.total_tokens;
        this.openTokenGifted(this.giftUserData.tokens, response.data.account_transaction);
      } else if (response.errors) {
        if (response.errors == 'OTP is incorrect') {
          this.hasError = true;
          this.errorMessage = response.errors;
        } else {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.errors;
        }
      } else {
        const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modelRef.componentInstance.message = "Error occured during a gifting tokens";
      }
    }, (error: any) => {
      this.spinner.hide();
      this.hasError = true;
      this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.OTP_INVALID;
    });
  }

  transferToken() {
    this.spinner.show();
    const params = {
      ...this.giftUserData,
      ...this.OTPForm.value
    }
    this._walletService.transferTokens(params).subscribe((response) => {
      this.spinner.hide();
      if (response.success) {
        let account_transaction = response.data.account_transaction;
        account_transaction.transaction_flow = 'debit';
        account_transaction.closing_balance = response.data.account.total_tokens;
        this._walletService.setTransaction(account_transaction);
        this.closeDialog();
        const modalRef = this.modalService.open(TokensGiftedComponent, { centered: true });
        modalRef.componentInstance.amount = this.giftUserData.tokens;
        modalRef.componentInstance.type = "Transferred";
      } else if (response.errors) {
        if (response.errors == 'OTP is incorrect') {
          this.hasError = true;
          this.errorMessage = response.errors;
        } else {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.errors;
        }

      } else {
        const modelref = this.modalService.open(ErrorMessageComponent, { centered: true });
        modelref.componentInstance.message = "Error occured during trasferring tokens";
      }
    }, (reason) => {
      const modelref = this.modalService.open(ErrorMessageComponent, { centered: true });
      modelref.componentInstance.message = "Error occured during trasferring tokens"
    });
  }
  openTokenAdded() {
    this.closeDialog();
    this.modalService.open(TokensAddedComponent, { centered: true });
  }

  openTokenGifted(amount, account_transaction) {
    this.closeDialog();
    this._walletService.setTransaction(account_transaction);
    const modalRef = this.modalService.open(TokensGiftedComponent, { centered: true });
    modalRef.componentInstance.amount = amount;
    modalRef.componentInstance.type = "Gifted";
  }

  startCountDown(counter) {
    this.counter = counter;
    let intervalId = setInterval(() => {
      this.counter = this.counter - 1;
      if (this.counter === 0) {
        clearInterval(intervalId);
      }
    }, 1000);
  }
  withdrawTokens() {
    this.spinner.show();
    const params = {
      ...this.giftUserData,
      ...this.OTPForm.value
    }
    this._walletService.withdrawTokens(params).subscribe((response) => {
      this.spinner.hide();
      if (response.success) {
        this.closeDialog();
        this._walletService.setTransaction(true);
        const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modalRef.componentInstance.message = "Withdraw tokens request has been submitted successfully";
      } else if (response.errors) {
        if (response.errors == 'OTP is incorrect') {
          this.hasError = true;
          this.errorMessage = response.errors;
        } else {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.errors;
        }
      } else {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = "Error occured during submitting withdraws token request.";
        modalRef.result.then((response) => {
          this.closeDialog();
        })
      }
    });
  }
  resenOTP() {
    this.hasError = false;
    this.otpResend = false;
    let reqObject = {
      ...this.paramData,
    }

    if (this.giftUserData && (this.giftUserData.source == 'giftTokenNoBack' || this.giftUserData.source == 'transferTokenNoBack' || this.giftUserData.source == 'withdrawtokennoback')) {
      reqObject['phone_number'] = this.phone_number.phone_number
      reqObject['is_number_change'] = true;
    } else {
      reqObject['phone_number'] = this.phone_number.country_code + "" + this.phone_number.phone_number
      reqObject['is_number_change'] = true;
    }
    if(!this.numFlag){
      reqObject = null;
    }
    
    this.spinner.show();
    this._walletService.getOTP(reqObject).subscribe(
      (response: any) => {
        if (response.success) {
          this.otpResend = true;
          this.spinner.hide();
          // const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          // modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.OTP_SENT_SUCCESS;
          this.ngOnInit();
        }
        else if(response.message) {
          this.spinner.hide();
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = response.message === 'Authenticate'? 'Sorry,Something went wrong. Please try again after some time.':response.message;
        } else if(response.errors){
          this.spinner.hide();
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = response.errors;
        }

      }, (error: any) => {
        this.spinner.hide();
      })
  }


  /**
   * Redirect user directly to stripe
   *
   * @memberof EnterOtpComponent
   */
  redirectToStripe() {
    this.spinner.show();
    this._walletService.addTokens(this.giftUserData).subscribe(
      (response: any) => {
        if (response.success) {
          this.sessionId = response.data.session_id;
          this.pay();
        } else {
          this.spinner.hide();
        }
      }, (error: any) => {
        this.spinner.hide();
      });
  }

  async pay() {
    this.spinner.show();
    const stripe = Stripe(environment.stripe_publication_key);
    const { error } = await stripe.redirectToCheckout({
      sessionId: this.sessionId
    });
    stripe.redirectToCheckout({
      sessionId: this.sessionId
    }).then(function (result) {
      alert("Not working")
    });
  }

  restrictNumeric(event) {
    this.hasError = false;
    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9]+$/))
      event.preventDefault();
    const restrictKeycodes = [101, 46, 43, 45];
    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 11) {
      return false;
    }
  }
  otpChange() {
    this.hasError = false;
  }

  /**
   * Allow only paste for digits
   *
   * @param {*} event
   * @returns
   * @memberof EnterOtpComponent
   */
  restrictNumericPaste(event) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE, "");

    this.OTPForm.patchValue({
      one_time_password: (this.OTPForm.get('one_time_password').value) ? (this.OTPForm.get('one_time_password').value.toString() + filteredText) : filteredText
    });
    event.preventDefault();
  }
}
